<div class="condominium-container">
  <div class="condominium-content">
    <router-outlet></router-outlet>
  </div>
</div>
